// extracted by mini-css-extract-plugin
module.exports = {"navDots":"B-MlfnenrVL9_5az0Q7Mi"};